document.addEventListener("DOMContentLoaded", () => {
    const path = window.location.pathname;
    if (path.startsWith("/en/")) {
        const ru = document.querySelector(".lang-block.ru");
        const en = document.querySelector(".lang-block.en");
        if (ru && en) en.parentNode.insertBefore(en, ru);
    }
});